import { settings } from '../constants';
import { get, post } from './FetchService';

class FsPlaylistService {
    constructor(){
        this.MpxPlaylist = null;
        this.parselyPlaylist = null;
    }

    getMpxPlaylist( endcard, limit ) {
		if (this.MpxPlaylist) {
			return this.MpxPlaylist;
        }
        this.MpxPlaylist = get( settings.MPX_PLAYLIST_URL + "?endcardfeed=" + encodeURIComponent(endcard) + "&limit=" + limit,
        json => {
            let data = json.data;
            return Array.isArray(data) ? data : [data];
        }, () => []);
        return this.MpxPlaylist;
    }

    getParselyPlaylist( postId ) {
        if (this.parselyPlaylist) {
			return this.parselyPlaylist;
		}

		this.parselyPlaylist = get(settings.PARSELY_URL + postId,
			json => {
				if (!json.success) return [];
				let data = json.data;
				return Array.isArray(data) ? data : [data];
			},
			() => []);

		return this.parselyPlaylist;
    }
    getParselyContentByFeed( parselyFeedTags = '', defaultVideoTags = '') {
        if (this.parselyPlaylist) {
			return this.parselyPlaylist;
		}

		let tags = '?parselytags=' + parselyFeedTags + ( defaultVideoTags && '&defaulttags=' + defaultVideoTags );
		this.parselyPlaylist = get(settings.PARSELY_URL_V2 + tags,
			json => {
				if (!json.success) return [];
				let data = json.data;
				return Array.isArray(data) ? data : [data];
			},
			() => []);

		return this.parselyPlaylist;
    }
}

export default FsPlaylistService;


// WEBPACK FOOTER //
// ./react-app-src/shared/services/FsPlaylistService.js